(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[868],{

/***/ 4029:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/[slug]",
      function () {
        return __webpack_require__(71812);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ IntegrationsMatchCtaBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./src/components/icons/ChevronForwardV4Icon.tsx
var ChevronForwardV4Icon = __webpack_require__(18805);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHeroIcons.tsx
var IntegrationsHeroIcons = __webpack_require__(10305);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/IntegrationsMatchCtaBlock.module.scss
var IntegrationsMatchCtaBlock_module = __webpack_require__(81793);
var IntegrationsMatchCtaBlock_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsMatchCtaBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/IntegrationsMatchCtaBlock.tsx










var DocsExternalArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.83333 2.83337H13.1667V10.1667",
                stroke: "currentColor",
                strokeWidth: 1.33,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.83337 13.1667V9.61115C2.83337 8.98648 3.06937 8.38737 3.48615 7.94337L13.1667 2.83337",
                stroke: "currentColor",
                strokeWidth: 1.33,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.83337 2.83337H13.1667V6.1667",
                stroke: "currentColor",
                strokeWidth: 1.33,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var DEFAULT_MATCH_HEADLINE = "Didn't find the perfect match?";
var DEFAULT_MATCH_DESCRIPTION = "Our integration library is constantly expanding. Contact us, and we'll customize a solution tailored to your specific business needs.";
var DEFAULT_VISUAL_CAPTION = "100+ integrations worldwide";
var DEFAULT_ASIDE_CAPTION_ID = "integrations-cta-globe-caption";
var IntegrationsMatchCtaBlock = function(param) {
    var _headline = param.headline, headline = _headline === void 0 ? DEFAULT_MATCH_HEADLINE : _headline, _description = param.description, description = _description === void 0 ? DEFAULT_MATCH_DESCRIPTION : _description, _visualCaption = param.visualCaption, visualCaption = _visualCaption === void 0 ? DEFAULT_VISUAL_CAPTION : _visualCaption, _asideCaptionId = param.asideCaptionId, asideCaptionId = _asideCaptionId === void 0 ? DEFAULT_ASIDE_CAPTION_ID : _asideCaptionId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (IntegrationsMatchCtaBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (IntegrationsMatchCtaBlock_module_default()).banner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (IntegrationsMatchCtaBlock_module_default()).copy,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "h2",
                            className: (IntegrationsMatchCtaBlock_module_default()).headline,
                            children: headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            whiteSpace: "normal",
                            className: (IntegrationsMatchCtaBlock_module_default()).description,
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (IntegrationsMatchCtaBlock_module_default()).actions,
                            gap: 12,
                            wrap: "wrap",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                    href: "#".concat(sections/* SECTIONS_IDS.contact */.s.contact),
                                    variant: "primary",
                                    iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {}),
                                    className: (0,clsx_m/* default */.Z)((IntegrationsMatchCtaBlock_module_default()).contactLinkPlain, (IntegrationsMatchCtaBlock_module_default()).contactSalesButton),
                                    children: "Contact Sales"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                    href: "/docs",
                                    isOutsideLink: true,
                                    variant: "primary",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsExternalArrowIcon, {}),
                                    className: (0,clsx_m/* default */.Z)((IntegrationsMatchCtaBlock_module_default()).contactLinkPlain, (IntegrationsMatchCtaBlock_module_default()).docsLinkButton),
                                    children: "API Documentation"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                    className: (IntegrationsMatchCtaBlock_module_default()).visual,
                    "aria-labelledby": asideCaptionId,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (IntegrationsMatchCtaBlock_module_default()).globeStage,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntegrationsMatchCtaBlock_module_default()).globeGlow,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntegrationsMatchCtaBlock_module_default()).globeCircle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (IntegrationsMatchCtaBlock_module_default()).globeIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHeroIcons/* IntegrationsHeroGlobeIcon */.KU, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            id: asideCaptionId,
                            type: "regular14",
                            align: "center",
                            whiteSpace: "normal",
                            className: (IntegrationsMatchCtaBlock_module_default()).globeSubtext,
                            children: visualCaption
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/index.ts



/***/ }),

/***/ 71812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/landingV4/FAQBlock/index.ts + 1 modules
var FAQBlock = __webpack_require__(51580);
// EXTERNAL MODULE: ./src/components/landingV4/FeedbackBlock/index.ts + 27 modules
var FeedbackBlock = __webpack_require__(52898);
// EXTERNAL MODULE: ./src/components/landingV4/Footer/index.ts + 1 modules
var Footer = __webpack_require__(60830);
// EXTERNAL MODULE: ./src/components/landingV4/Header/index.ts + 8 modules
var Header = __webpack_require__(13906);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/index.ts + 1 modules
var IntegrationsMatchCtaBlock = __webpack_require__(34148);
// EXTERNAL MODULE: ./src/components/landingV4/SnackbarProvider/index.ts + 4 modules
var SnackbarProvider = __webpack_require__(7513);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMethodSpecsBlock/MethodSpecsIcons.tsx
var MethodSpecsIcons = __webpack_require__(10461);
// EXTERNAL MODULE: ./src/components/landingV4/SolutionPage/SolutionFeaturesBlock.module.scss
var SolutionFeaturesBlock_module = __webpack_require__(95974);
var SolutionFeaturesBlock_module_default = /*#__PURE__*/__webpack_require__.n(SolutionFeaturesBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/SolutionPage/SolutionFeaturesBlock.tsx





var SolutionFeaturesBlock = function(props) {
    var sectionTitle = props.sectionTitle, items = props.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: (SolutionFeaturesBlock_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SolutionFeaturesBlock_module_default()).sectionHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SolutionFeaturesBlock_module_default()).sectionIcon,
                        "aria-hidden": true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodSpecsIcons/* MethodSpecsBookIcon */.ZL, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (SolutionFeaturesBlock_module_default()).sectionTitle,
                        children: sectionTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SolutionFeaturesBlock_module_default()).cards,
                children: items.map(function(param) {
                    var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: (SolutionFeaturesBlock_module_default()).card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SolutionFeaturesBlock_module_default()).cardIconWrap,
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "h3",
                                color: "white",
                                className: (SolutionFeaturesBlock_module_default()).cardTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "regular14",
                                color: "white50",
                                whiteSpace: "normal",
                                className: (SolutionFeaturesBlock_module_default()).cardDescription,
                                children: description
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/TextLink/index.ts + 1 modules
var TextLink = __webpack_require__(46370);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHero.module.scss
var IntegrationsHero_module = __webpack_require__(39095);
var IntegrationsHero_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsHero_module);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/IntegrationsMatchCtaBlock.module.scss
var IntegrationsMatchCtaBlock_module = __webpack_require__(81793);
var IntegrationsMatchCtaBlock_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsMatchCtaBlock_module);
// EXTERNAL MODULE: ./src/components/landingV4/SolutionPage/SolutionPageHero.module.scss
var SolutionPageHero_module = __webpack_require__(31053);
var SolutionPageHero_module_default = /*#__PURE__*/__webpack_require__.n(SolutionPageHero_module);
;// CONCATENATED MODULE: ./src/components/landingV4/SolutionPage/SolutionPageHero.tsx











var SolutionPageHero = function(props) {
    var eyebrowLabel = props.eyebrowLabel, headline = props.headline, subheadline = props.subheadline;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (IntegrationsHero_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (IntegrationsHero_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                alignItems: "flexStart",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsHero_module_default()).sectionLabel,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (IntegrationsHero_module_default()).sectionLabelLine,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "medium14",
                                color: "green",
                                className: (IntegrationsHero_module_default()).sectionEyebrow,
                                children: eyebrowLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "regular48",
                        color: "white",
                        className: (IntegrationsHero_module_default()).title,
                        children: headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "regular16",
                        color: "white50",
                        whiteSpace: "normal",
                        className: (IntegrationsHero_module_default()).description,
                        children: subheadline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (SolutionPageHero_module_default()).actions,
                        gap: 12,
                        wrap: "wrap",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                href: "#".concat(sections/* SECTIONS_IDS.contact */.s.contact),
                                variant: "primary",
                                className: (0,clsx_m/* default */.Z)((IntegrationsMatchCtaBlock_module_default()).contactLinkPlain, (IntegrationsMatchCtaBlock_module_default()).contactSalesButton, (SolutionPageHero_module_default()).primaryCta),
                                children: "Get Started Now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* TextLink */.h, {
                                href: "/docs",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                isOutsideLink: true,
                                variant: "green",
                                type: "medium16",
                                children: "View Documentation"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/SolutionPage/solutionPagesData.ts + 7 modules
var solutionPagesData = __webpack_require__(85671);
// EXTERNAL MODULE: ./src/components/layout/MainLayout/EmptyLayout.tsx
var EmptyLayout = __webpack_require__(46615);
;// CONCATENATED MODULE: ./src/pages/solutions/[slug].tsx













var Page = function(props) {
    var slug = props.slug;
    (0,react.useLayoutEffect)(function() {
        document.documentElement.classList.add("v4");
        document.documentElement.style.setProperty("--background", "#09090B");
        return function() {
            document.documentElement.classList.remove("v4");
            document.documentElement.style.removeProperty("--background");
        };
    }, []);
    var solution = (0,solutionPagesData/* getSolutionPageBySlug */.Tp)(slug);
    if (!solution) {
        return null;
    }
    var headline = solution.headline, metaTitleSuffix = solution.metaTitleSuffix, docDescription = solution.docDescription;
    var captionId = "solution-match-cta-".concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SnackbarProvider/* SnackbarProvider */.w, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(metaTitleSuffix, " | SmartGates")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: docDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SolutionPageHero, {
                eyebrowLabel: solution.solutionEyebrowLabel,
                headline: headline,
                subheadline: solution.subheadline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SolutionFeaturesBlock, {
                sectionTitle: solution.featuresSectionTitle,
                items: solution.features
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsMatchCtaBlock/* IntegrationsMatchCtaBlock */.H, {
                headline: solution.ctaHeadline,
                asideCaptionId: captionId,
                visualCaption: solution.ctaVisualCaption
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQBlock/* FAQBlock */.C, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackBlock/* FeedbackBlock */.O, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};
Page.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyLayout/* EmptyLayout */.T, {
        withFloatMenu: false,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Page);


/***/ }),

/***/ 39095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsHero_root__RI5Te","inner":"IntegrationsHero_inner__ZejqT","sectionEyebrow":"IntegrationsHero_sectionEyebrow__j_OWD","sectionLabel":"IntegrationsHero_sectionLabel__oXXCL","sectionLabelLine":"IntegrationsHero_sectionLabelLine__hiYVX","title":"IntegrationsHero_title__hBj_7","description":"IntegrationsHero_description__MozzB","badges":"IntegrationsHero_badges__eRcJd","badge":"IntegrationsHero_badge__QNFhB","badgeIcon":"IntegrationsHero_badgeIcon__gK_Eq"};

/***/ }),

/***/ 81793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsMatchCtaBlock_root__N7i_M","banner":"IntegrationsMatchCtaBlock_banner__0jXKx","copy":"IntegrationsMatchCtaBlock_copy__UeZ1w","headline":"IntegrationsMatchCtaBlock_headline__PnMvc","description":"IntegrationsMatchCtaBlock_description__X7r6Y","actions":"IntegrationsMatchCtaBlock_actions__yz1Ha","visual":"IntegrationsMatchCtaBlock_visual__nontv","globeStage":"IntegrationsMatchCtaBlock_globeStage__TpCwU","globeGlow":"IntegrationsMatchCtaBlock_globeGlow___1oSl","globeCircle":"IntegrationsMatchCtaBlock_globeCircle__Lo2Gi","globeIcon":"IntegrationsMatchCtaBlock_globeIcon__q3sbz","globeSubtext":"IntegrationsMatchCtaBlock_globeSubtext__b_MrV","contactLinkPlain":"IntegrationsMatchCtaBlock_contactLinkPlain__jhZ2R","contactSalesButton":"IntegrationsMatchCtaBlock_contactSalesButton__yt01L","docsLinkButton":"IntegrationsMatchCtaBlock_docsLinkButton__mqpbP"};

/***/ }),

/***/ 95974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"SolutionFeaturesBlock_root__681j5","sectionHead":"SolutionFeaturesBlock_sectionHead__5mt9P","sectionIcon":"SolutionFeaturesBlock_sectionIcon__EdyTM","sectionTitle":"SolutionFeaturesBlock_sectionTitle__jXZkB","cards":"SolutionFeaturesBlock_cards__Pwpv5","card":"SolutionFeaturesBlock_card__MrJ_B","cardIconWrap":"SolutionFeaturesBlock_cardIconWrap__epSYp","cardTitle":"SolutionFeaturesBlock_cardTitle__fBli8","cardDescription":"SolutionFeaturesBlock_cardDescription__CIf43"};

/***/ }),

/***/ 31053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"actions":"SolutionPageHero_actions__xP7Sx","primaryCta":"SolutionPageHero_primaryCta__nFCqC"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [536,522,928,834,168,671,961,774,888,179], function() { return __webpack_exec__(4029); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);